import React from 'react';
import { connect } from 'react-redux';
import { UpdateUser, UpdateUserProfilePhoto } from 'actions';
import { UserProfileForm } from 'components/forms';
import Spinner from 'components/spinner';
import useScrollTop from 'hooks/useScrollTop';
import { IFile } from 'services';
import { IAppState, IUser } from 'types';
import UserTabs from './components/UserTabs';
import styles from './styles/UserContainer.module.scss';
import { useAuth0 } from '../../react-auth0-spa';

interface IDispatchProps {
  updateProfilePhoto(file: IFile): void;
  updateUser(user: IUser): (dispatch: any) => void;
}

const UserContainer = ({
  user,
  updateUser,
  updateProfilePhoto,
}: IAppState & IDispatchProps) => {
  useScrollTop();
  const auth0 = useAuth0();

  if (!user.id) {
    return <Spinner className={styles.loading} loading={true} />;
  }

  return (
    <div className={styles.container}>
      <UserProfileForm
        user={user}
        auth0={auth0}
        updateUser={updateUser}
        updateProfilePhoto={updateProfilePhoto}
      />
      <UserTabs user={user} />
    </div>
  );
};

const mapStateToProps = (state: IAppState) => {
  return {
    ...state,
  };
};

const mapDispatchToProps = {
  updateUser: UpdateUser,
  updateProfilePhoto: UpdateUserProfilePhoto,
};

export default connect<IAppState, IDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(UserContainer);
